export const statsData = [
  { number: '+3500', label: 'عميل راضٍ' },
  { number: '+450', label: 'تطبيق ناجح' },
  { number: '+250', label: 'موظف وموظفة' },
  { number: '+50000', label: 'زيارة شهرية' },
];

export const featuresData = [
  {
    icon: 'ri-layout-masonry-line',
    title: 'تصميم واجهات احترافية UX/UI',
    description: 'تصاميم عصرية تركز على تجربة المستخدم وتحقيق أهداف عملك',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'برمجة آمنة وسريعة',
    description: 'كود نظيف ومُحسّن يضمان سرعة التحميل وحماية البيانات',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'توافق كامل مع الجوال',
    description: 'تصميم متجاوب يعمل بشكل مثالي على جميع الأجهزة والشاشات',
  },
  {
    icon: 'ri-search-line',
    title: 'تهيئة أساسية لمحركات البحث SEO',
    description: 'بنية صحيحة ومحتوى مهيأ يساعدك على الظهور في نتائج البحث',
  },
  {
    icon: 'ri-whatsapp-line',
    title: 'ربط واتساب ونماذج التواصل',
    description: 'تواصل مباشر مع عملائك عبر واتساب ونماذج تواصل ذكية',
  },
  {
    icon: 'ri-dashboard-line',
    title: 'لوحة تحكم سهلة لإدارة المحتوى',
    description: 'تحكم كامل في محتوى موقعك بدون الحاجة لخبرة تقنية',
  },
  {
    icon: 'ri-server-line',
    title: 'حماية واستضافة اختيارية',
    description: 'حلول استضافة آمنة وموثوقة مع نسخ احتياطية دورية',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'دعم فني بعد التسليم',
    description: 'فريق دعم متخصص جاهز لمساعدتك بعد إطلاق موقعك',
  },
];

export const workStepsData = [
  {
    step: '01',
    title: 'تحليل النشاط والجمهور',
    description: 'نبدأ بفهم نشاطك، جمهورك المستهدف، وأهدافك لنبني استراتيجية واضحة.',
  },
  {
    step: '02',
    title: 'تصميم تجربة المستخدم والواجهة',
    description: 'نصمم واجهات جذابة وسهلة الاستخدام تركز على تحويل الزوار إلى عملاء.',
  },
  {
    step: '03',
    title: 'البرمجة والتطوير',
    description: 'نبرمج موقعك بأحدث التقنيات مع ضمان الأداء والأمان والتوافق مع جميع المتصفحات.',
  },
  {
    step: '04',
    title: 'الاختبار وتحسين السرعة',
    description: 'نختبر الموقع على مختلف الأجهزة ونحسن سرعته لأفضل تجربة ممكنة.',
  },
  {
    step: '05',
    title: 'الإطلاق والدعم',
    description: 'نطلق موقعك ونقدم الدعم المستمر لضمان استمرارية النجاح.',
  },
];

export const servicesData = [
  { icon: 'ri-building-line', title: 'تصميم مواقع الشركات', description: 'مواقع احترافية تعكس هوية شركتك وتبني الثقة مع عملائك' },
  { icon: 'ri-advertisement-line', title: 'تصميم صفحات هبوط لإعلانات جوجل', description: 'صفحات هبوط محسّنة لتحويل إعلاناتك إلى عملاء حقيقيين' },
  { icon: 'ri-code-box-line', title: 'برمجة مواقع مخصصة', description: 'حلول برمجية مخصصة تلبي احتياجات عملك الفريدة' },
  { icon: 'ri-store-3-line', title: 'تطوير متاجر إلكترونية', description: 'متاجر إلكترونية متكاملة لبيع منتجاتك وخدماتك عبر الإنترنت' },
  { icon: 'ri-user-smile-line', title: 'تحسين تجربة المستخدم', description: 'تحليل وتحسين تجربة المستخدم لزيادة التفاعل والمبيعات' },
  { icon: 'ri-tools-line', title: 'صيانة وتطوير المواقع الحالية', description: 'تحديث وصيانة موقعك الحالي لتحسين الأداء والأمان' },
];

export const portfolioData = [
  { title: 'موقع شركة', category: 'موقع شركة', image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20website%20mockup%20displayed%20on%20laptop%20screen%20with%20clean%20teal%20and%20white%20design%20professional%20business%20layout%20minimal%20interface%20on%20light%20background%20high%20quality%20render&width=600&height=400&seq=1&orientation=landscape' },
  { title: 'متجر إلكتروني', category: 'متجر إلكتروني', image: 'https://readdy.ai/api/search-image?query=Ecommerce%20website%20mockup%20on%20multiple%20devices%20showing%20product%20grid%20modern%20shopping%20interface%20clean%20design%20with%20teal%20accents%20professional%20online%20store%20render&width=600&height=400&seq=2&orientation=landscape' },
  { title: 'منصة خدمات', category: 'منصة خدمات', image: 'https://readdy.ai/api/search-image?query=Service%20platform%20website%20mockup%20dashboard%20style%20modern%20web%20application%20interface%20clean%20teal%20green%20accents%20professional%20SaaS%20layout%20on%20light%20background&width=600&height=400&seq=3&orientation=landscape' },
  { title: 'موقع تعريفي', category: 'موقع تعريفي', image: 'https://readdy.ai/api/search-image?query=Personal%20portfolio%20website%20mockup%20elegant%20landing%20page%20modern%20web%20design%20with%20teal%20accents%20professional%20creative%20agency%20layout%20on%20light%20background%20high%20quality&width=600&height=400&seq=4&orientation=landscape' },
];

export const whyAAITData = [
  { icon: 'ri-lightbulb-flash-line', title: 'الابتكار', description: 'نستثمر في أحدث التقنيات لنقدم حلولًا مبتكرة تضعك في المقدمة' },
  { icon: 'ri-award-line', title: 'الجودة', description: 'معايير صارمة في كل مرحلة لضمان تسليم منتج يفوق توقعاتك' },
  { icon: 'ri-time-line', title: 'الالتزام بالمواعيد', description: 'نحترم وقتك ونلتزم بالجدول الزمني المتفق عليه بدقة عالية' },
  { icon: 'ri-customer-service-line', title: 'خدمات ما بعد البيع', description: 'دعم مستمر وصيانة دورية لضمان استمرارية أعمالك بدون توقف' },
  { icon: 'ri-message-3-line', title: 'التواصل المستمر والدعم الفني', description: 'فريق متخصص جاهز للرد على استفساراتك وحل أي مشكلة على مدار الساعة' },
];

export const testimonialsData = [
  {
    name: 'عبدالله المالكي',
    role: 'صاحب متجر إلكتروني',
    content: 'فريق أوامر الشبكة ساعدنا في إطلاق موقع احترافي يعكس هوية شركتنا. التعاون كان ممتاز من البداية حتى النهاية.',
    rating: 5,
  },
  {
    name: 'سارة القحطاني',
    role: 'مديرة شركة استشارات',
    content: 'التجربة كانت منظمة من أول اجتماع حتى الإطلاق. كل خطوة كانت واضحة والفريق محترف جداً في التعامل.',
    rating: 5,
  },
  {
    name: 'فهد العتيبي',
    role: 'مؤسس مشروع ناشئ',
    content: 'الموقع أصبح أسرع وأسهل لعملائنا، وفريق الدعم متعاون ويستجيب بسرعة لأي طلب. أنصح بالتعامل معهم بشدة.',
    rating: 5,
  },
];

export const navLinks = [
  { label: 'الرئيسية', href: '#hero' },
  { label: 'المميزات', href: '#features' },
  { label: 'مراحل العمل', href: '#steps' },
  { label: 'أعمالنا', href: '#portfolio' },
  { label: 'الأسئلة الشائعة', href: '#faq' },
  { label: 'تواصل معنا', href: '#cta' },
];

export const faqData = [
  {
    question: 'كم تستغرق مدة تصميم موقع إلكتروني؟',
    answer: 'تتراوح مدة تصميم وبرمجة الموقع الإلكتروني بين أسبوعين إلى شهر حسب حجم المشروع وتعقيده.',
  },
  {
    question: 'هل تقدمون خدمة SEO مع الموقع؟',
    answer: 'نعم، نقوم بتهيئة الموقع لمحركات البحث SEO بشكل أساسي مع كل مشروع.',
  },
  {
    question: 'هل يمكنني إدارة محتوى الموقع بنفسي؟',
    answer: 'نعم، نوفر لوحة تحكم سهلة تمكنك من تحديث المحتوى والصور دون خبرة تقنية.',
  },
  {
    question: 'هل تقدمون دعمًا بعد إطلاق الموقع؟',
    answer: 'بالتأكيد، فريق الدعم الفني متاح لمساعدتك في الصيانة والتحديثات بعد التسليم.',
  },
];